import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=3fcd7111&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=3fcd7111&prod&scoped=true&lang=stylus"
import style1 from "./privacy-policy.vue?vue&type=style&index=1&id=3fcd7111&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd7111",
  null
  
)

export default component.exports